export function getTaskRows (seq) {
  const rows = seq && (seq.tasks || seq.taskStates)
  return Array.isArray(rows) ? rows : []
}

export function getTaskStats (rows) {
  if (!rows || !rows.length) {
    return {
      total: 0,
      complete: 0,
      progress: 0,
      isStarted: false
    }
  }

  const total = rows.reduce((sum, t) => sum + Number(t.count || 0), 0)
  const complete = rows
    .filter(t => t.state === 'complete')
    .reduce((sum, t) => sum + Number(t.count || 0), 0)

  return {
    total,
    complete,
    progress: total ? complete / total : 0,
    isStarted: total > 0
  }
}

/**
 * Not started → no tasks | Ready → all complete | Active → processing | In progress → partial
 */
export function getStatusLabel (seq, stats) {
  if (!stats.isStarted) {
    return { labelKey: 'terminal.sequence.statusNotStarted', color: 'warning' }
  }
  if (stats.total > 0 && stats.complete === stats.total) {
    return { labelKey: 'terminal.sequence.statusReady', color: 'positive' }
  }
  if (seq.state === 'processing') {
    return { labelKey: 'terminal.sequence.statusActive', color: 'primary' }
  }
  return { labelKey: 'terminal.sequence.statusInProgress', color: 'info' }
}

export function enrichSequence (seq) {
  const rows = getTaskRows(seq)
  const stats = getTaskStats(rows)
  const status = getStatusLabel(seq, stats)
  return {
    ...seq,
    _taskStats: stats,
    _status: status,
    _taskRows: rows
  }
}
